import React, { useState, useEffect, useCallback } from 'react';
import { Navigate } from "react-router-dom";

import Grid from '@mui/material/Grid2';

import { ModelBase, PlayerObject } from "@models";
import { UserTicket } from "@models/Ticket";

import API from "@dndUtilities/system_api";

import ObjectIndex from "@components/Navigation/ObjectIndex";
import LoadingBox from "@components/input/LoadingBox";

const api = API.getInstance();

export default function UserTicketIndex() {
  const [fetched, setFetched] = useState(false);
  const [logging_in, setLoggingIn] = useState(false);
  const [navigateTo, setNavigateTo] = useState<string | null>(null);

  const check_login = useCallback(() => {
    setTimeout(() => {
      if (api.user === null) {
        check_login();
      } else {
        setLoggingIn(false);
      }
    }, 1000);
  }, []);
  
  const load = useCallback( async () => {
    await api.getObjects({ data_type: "ticket" });
    if (api.user === null && api.online) {
      const userObjStr = localStorage.getItem("loginUser");
      if (!userObjStr) {
        setNavigateTo("/");
      } else {
        setLoggingIn(true);
        check_login();
      }
    }
  }, [check_login]);
  
  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      load();
    }
  }, [fetched, load]);

  const get_true_filter = () => {
    const filter: any = {};
    const user = api.user;
    if (user) {
      if (user.admin) {

      } else {
        filter["$or"] = [{ owner_id: user._id },{ player_ids: user._id }];
      }
    } else {
      filter.owner_id = "No Login";
    }
    return filter;
  }

  if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else if (logging_in) {
    return <span>Logging In</span>;
  } else if (api.user === null) {
    return <Navigate to="/" />;
  } else if (!api.online) {
    return (
      <>User Tickets unavailable when offline.</>
    );
  } else if (!fetched) {
    return (<div className="centered"><LoadingBox size={window.innerHeight * 0.5} height={window.innerHeight - 81} /></div>); // width={window.innerWidth - 17}
  } else {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          <ObjectIndex 
            true_filter={get_true_filter()}
            data_type="user_ticket"
            exclude_options={["Add"]}
            name_display={(obj) => {
              if (obj instanceof UserTicket) {
                return obj.subject;
              }
              return obj.name;
            }}
            // log_it
          />
        </Grid>
      </Grid>
    ); 
  } 
}
